module.exports = __webpack_public_path__ + "img/Office_Group_Laptop_Foreground_Scorecard_Row.391a536f.jpg";